import { render } from "./HomeContest.vue?vue&type=template&id=bd0a1f9e&scoped=true"
import script from "./HomeContest.vue?vue&type=script&lang=js"
export * from "./HomeContest.vue?vue&type=script&lang=js"

import "./HomeContest.vue?vue&type=style&index=0&id=bd0a1f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0a1f9e"]])

export default __exports__